import { MonthRangePicker } from 'app/components/common/DatePickers';
import { AgenturNameCell } from 'app/components/shared/AgenturName.cell';
import { Table } from 'app/components/table/table';
import { AggregrationType, ITableColumn, tableDividerColumnWithAgg, TableModel } from 'app/components/table/table.model';
import { useStore } from 'app/context';
import { observer } from 'mobx-react';
import { useEffect, useMemo, useRef, useState } from 'react';
import { formatPercentWithIcon } from 'app/utils';
import { useLocation } from 'react-router';
import { useHistoryWithQuery } from 'app/hooks/useHistoryWithQuery';
import { amisNowProps } from 'app/stores/ui/agt.amisnow.ui.store';
import { AgtFitnessVm } from 'app/stores/ui/agt.fitness.ui.store';
import _ from 'lodash';
import { runInAction } from 'mobx';

export const AmisNowOptions = observer(() => {
	const { agtAmisNowUiStore } = useStore();

	const onMinChange = (value: number) => {
		runInAction(() => {
			agtAmisNowUiStore.minBmCurrent = value;
		});
	};

	const onMaxChange = (value: number) => {
		runInAction(() => {
			agtAmisNowUiStore.maxBmCurrent = value;
		});
	};

	return (
		<MonthRangePicker
			minValue={agtAmisNowUiStore.minBm}
			maxValue={agtAmisNowUiStore.maxBm}
			opts={agtAmisNowUiStore.bmOpts}
			onMinChange={onMinChange}
			onMaxChange={onMaxChange}
			emptyTextMin="Start Monat"
			emptyTextMax="End Monat"
			queryParam="bm"
		/>
	);
});

export const AmisNowListe = observer(() => {
	const { berichteUiiStore, agtAmisNowUiStore, agtFitnessUiStore, agenturListUiStore } = useStore();
	const [hasItems, setHasItems] = useState(false);

	const [selectedAgtId, setSelectedAgtId] = useState<number | undefined>(undefined);
	const history = useHistoryWithQuery();
	const location = useLocation();

	const tm = useMemo(() => {
		const tm = new TableModel<AgtFitnessVm, number>();
		const cols: ITableColumn<AgtFitnessVm, number>[] = [];

		cols.push({
			label: 'Agentur',
			path: 'agt.name',
			sortBy: 'agt.name',
			render: AgenturNameCell,
		});

		/// AMIS.NOW
		const columns = amisNowProps.sort((a, b) => a.sort - b.sort);
		columns.forEach((prop, i) => {
			cols.push({
				label: prop.label,
				path: prop.path,
				sortBy: prop.path,
				cellModifier: `${i === 0 && 'border-left-turquoise'} bg-turquoise`,
				labelModifier: `${i === 0 && 'border-left-turquoise'} bg-turquoise`,
				format: prop.path === 'amisNow.aggregated.quoteRead' ? (val) => formatPercentWithIcon(val * 100, 1) : undefined,
				agg: {
					aggType: prop.path === 'amisNow.aggregated.quoteRead' ? AggregrationType.avg : AggregrationType.sum,
					format: prop.path === 'amisNow.aggregated.quoteRead' ? (val) => formatPercentWithIcon(val * 100, 1) : undefined,
				},
			});
		});

		cols.push(tableDividerColumnWithAgg);

		tm.sortBy = 'agt.name';
		tm.setCols(cols);

		// tm.onRowClick = (row) => {
		// 	const p = routes.BERICHTE.getPath('kunde', 'amisnow', 'liste', row.data.agt.agtId.toString());
		// 	history.pushWithQuery(p);
		// };

		tm.idProperty = 'agtId';
		tm.idType = 'number';

		return tm;
	}, []);

	useEffect(() => {
		// Load the AMISNOW store first to get available data
		agtAmisNowUiStore.load().then(() => {
			// Force a reload of fitness store to pick up the AMISNOW data with current filters
			agtFitnessUiStore.clearCache();
			return agtFitnessUiStore.load();
		}).then(() => {
			let items = agtFitnessUiStore.items.filter(item => item.amisNow && item.amisNow);
			if (berichteUiiStore.selectedAgt) {
				const agtId = berichteUiiStore.selectedAgt.agtId;
				items = items.filter((i) => i.agt.agtId === agtId);
			} else {
				items = agenturListUiStore.applyFilterOnAgt(items) as AgtFitnessVm[];
			}
			setHasItems(items.length > 0);
			tm.setRowData(items);
			tm.sort();
		});
	}, [
		tm,
		berichteUiiStore.selectedAgt,
		agenturListUiStore.filterHasChanged,
		agenturListUiStore,
		agtAmisNowUiStore.maxBm,
		agtAmisNowUiStore.minBm,
		agtAmisNowUiStore,
		agtFitnessUiStore
	]);

	useEffect(() => {
		// Handle URL navigation for agency details
		const lastPathElement = location.pathname.split('/').pop();
		let agtId;
		if (typeof lastPathElement === 'string') {
			agtId = parseInt(lastPathElement);
		}
		if (agtId && !isNaN(agtId)) {
			setSelectedAgtId(agtId);
		} else {
			setSelectedAgtId(undefined);
		}
	}, [location]);


	return (
		<>
			<div className="table-container">
				{/* <AmisNowOptions /> */}
				{!hasItems ? (
					<div className="pad-1rem">Keine AMIS.NOW Aufgaben gefunden</div>
				) : (
					<>
						<Table stickyHeader={true} stickyFooter={true} tm={tm}></Table>
					</>
				)}
			</div>
		</>
	);
});


